<div id="oidc-login">
  <form (submit)="onSubmit($event)" #f="ngForm">
    <button type="submit" class="btn btn-primary">
      <clr-icon shape="cloud"></clr-icon> Sign in with Microsoft
    </button>
  </form>

  <div class="alert alert-danger" role="alert" *ngIf="error_msg">
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <clr-icon class="alert-icon" shape="exclamation-circle"></clr-icon>
        </div>
        <span class="alert-text">
          {{ error_msg }}
        </span>
      </div>
    </div>
  </div>
</div>
